import { api } from '@lipaflow/shared'

/** Start free sign-ups: where they went, and the emergency brake. */

export interface SignupCounts {
  submitted: number
  opened_automatically: number
  waiting_for_review: number
  confirmed_email: number
  went_live: number
}

export interface SignupSummary {
  manual_review: boolean
  last_hour: number
  spike: boolean
  spike_threshold_per_hour: number
  last_24_hours: SignupCounts
  period_days: number
  period: SignupCounts
  setup: {
    in_setup: number
    past_warning_day: number
    offboarding_awaiting_approval: number
  }
}

/** A sector's sign-ups and its review brake (admin sector workspaces). */
export const signupsService = {
  async summary(sector: string, days = 7): Promise<SignupSummary> {
    const res = await api.get<SignupSummary>('/admin/signups/summary', { params: { vertical_code: sector, days } })
    return res.data
  },
  async setManualReview(sector: string, enabled: boolean, reason: string): Promise<{ manual_review: boolean }> {
    const res = await api.put<{ manual_review: boolean }>(
      '/admin/signups/manual-review',
      { enabled, reason },
      { params: { vertical_code: sector } },
    )
    return res.data
  },
}
